import * as SentryReact from "@sentry/react";

export function setSentryUser(
	user: {
		id?: number;
		username?: string;
		email?: string;
	} | null,
) {
	if (!import.meta.env.VITE_SENTRY_DSN) return;

	if (user) {
		const sentryUser: SentryReact.User = {};
		if (user.id) sentryUser.id = String(user.id);
		if (user.username) sentryUser.username = user.username;
		if (user.email) sentryUser.email = user.email;
		SentryReact.setUser(sentryUser);
	} else {
		SentryReact.setUser(null);
	}
}
